<div id="auth-screen" [ngClass]="userRole === 'internal' ? 'internal' : 'customer' ">

  @if (stage === 'enter') {
    <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper">
      <h2 class="font-small-icon color-title-grey text-center">Aktivierung des Benutzerkontos</h2>
      <input type="text" [(ngModel)]="email" name="email" placeholder="Benutzerkennung eingeben" (change)="trimWhiteSpace($event)">
      <button (click)="getActivationCode()" class="single-wide-btn green mt-m mb-m">Aktivierungscode zusenden</button>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="goBack()">Zurück zum Login</a>
    </div>
  }

  @if (stage === 'code') {
    <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper">
      <span class="am-flex-center color-green font-100 icon-ami-tick-circle"></span>
      <p class="text-l text-center">Ein Aktivierungscode wurde per E-Mail gesendet. Bitte geben Sie den zugesendeten Aktivierungscode ein:</p>
      <input type="text" [(ngModel)]="code" name="code" placeholder="Aktiverungscode eingeben" (change)="trimWhiteSpace($event)" autocomplete="new-password">
      <button (click)="activateAccount()" class="single-wide-btn green mt-m mb-m">OK</button>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="goBack()">Zurück zum Login</a>
    </div>
  }

  @if (stage === 'password') {
    <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper">
      <span class="am-flex-center color-blue font-100 icon-ami-user-card"></span>
      <p class="text-l text-center">Bitte legen Sie das Passwort für Ihr Benutzerkonto fest:</p>
      <input type="password" [(ngModel)]="password"         placeholder="Passwort"            autocomplete="new-password">
      <input type="password" [(ngModel)]="password_confirm" placeholder="Passwort bestätigen" autocomplete="new-password">
      <button (click)="setPassword()" class="form-group green wide-btn  mt-m mb-m">Speichern</button>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="goBack()">Zurück zum Login</a>
    </div>
  }

  @if (stage === 'code') {
    <div class="am-flex-column am-flex-align gap-s pt-s pb-s pl-m pr-m mb-l bg-white b-white text-center absolute-bottom-center">
      <h5>Keinen Aktivierungscode erhalten?</h5>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="getActivationCode()">Erneut versenden</a>
    </div>
  }

</div>
